import { render, staticRenderFns } from "./FormulateTextPercentage.vue?vue&type=template&id=2d7f2f80&"
import script from "./FormulateTextPercentage.vue?vue&type=script&lang=js&"
export * from "./FormulateTextPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7f2f80')) {
      api.createRecord('2d7f2f80', component.options)
    } else {
      api.reload('2d7f2f80', component.options)
    }
    module.hot.accept("./FormulateTextPercentage.vue?vue&type=template&id=2d7f2f80&", function () {
      api.rerender('2d7f2f80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/text-percetage/FormulateTextPercentage.vue"
export default component.exports